import { Point } from "../../../../domain/drawing";

export class KeyCodeProcessor {
  static toMoveOffset(keyCode: number): Point {
    // TODO: keyCodeは定数値かを検討する事.
    // ブラウザによって仕様が違うようなので、はっきりしてから考える.
    if (keyCode === 0x25) {         // ArrowLeft.
      return new Point(-1, 0);
    } else if (keyCode === 0x26) {  // ArrowUp.
      return new Point(0, -1);
    } else if (keyCode === 0x27) {  // ArrowRight.
      return new Point(1, 0);
    } else if (keyCode === 0x28) {  // ArrowDown.
      return new Point(0, 1);
    }
    return null;
  }
}
